const SIZE_BASE = 1024,
    SIZE_PRECISION = 2,
    SIZE_UNITS = ['byte', 'kib', 'mib', 'gib', 'tib', 'pib', 'eib'],
    SPEED_UNITS = ['byteps', 'kibps', 'mibps', 'gibps', 'tibps', 'pibps', 'eib'];
const FILE_SAVER = require('file-saver');
const OS = { WINDOWS: 'WINDOWS', LINUX: 'LINUX' };

class UtilsService {
    constructor($state, $q, $window, $sce, $filter, $timeout, $document, $http, principalService, notificationService, config, storageService, translateService) {
        this.$state = $state;
        this.$window = $window;
        this.$sce = $sce;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$document = $document;
        this.$http = $http;
        this.principalService = principalService;
        this.storageService = storageService;
        this.translateService = translateService;
        this.notificationService = notificationService;
        this.localDateFormatList = config.dateFormats;
    }

    isUserRole() {
        return {
            // viewer: this.principalService.isInUserRole(['VIEWER']),
            // backup_operator: this.principalService.isInUserRole(['VIEWER', 'BACKUP_OPERATOR']),
            // restore_operator: this.principalService.isInUserRole(['VIEWER', 'RESTORE_OPERATOR']),
            // admin: this.principalService.isInUserRole(['ADMINISTRATOR'])
            admin: true
        };
    }

    getDefaultOS() {
        return OS;
    }

    getOSType(operatingSystem) {
        return !operatingSystem ? null : operatingSystem.toLowerCase().indexOf('windows') >= 0 ? OS.WINDOWS : operatingSystem.toLowerCase().indexOf('linux') >= 0 ? OS.LINUX : operatingSystem;
    }

    setDefault(object, value) {
        return (typeof object === 'undefined') ? value : object;
    }

    repalceByUuid(arr, newItem) {
        let i = arr.indexOf(arr.filter(a => a.uuid === newItem.uuid)[0]);
        arr.splice(i, 1, newItem);
    }
    dynamicSort(property) {
        let sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return (a, b) => {
            let result;
            if (typeof a[property] === 'string') {
                result = (a[property].toUpperCase() < b[property].toUpperCase()) ? -1 : (a[property].toUpperCase() > b[property].toUpperCase()) ? 1 : 0;
            } else {
                result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            }
            return result * sortOrder;
        };
    }

    isBackUpAdmin() {
        return this.principalService.isInAnyRole(['Built-in Administrator', 'Administrator']);
    }

    saveData(data, fileName, type) {
        let blob = new Blob([data], { type });
        FILE_SAVER.saveAs(blob, fileName);
    }

    fromBytes(bytes, showSpeed = false, precision = SIZE_PRECISION) {
        if (bytes === 0 || bytes === '0') return { value: 0, unit: showSpeed ? SPEED_UNITS[0] : SIZE_UNITS[0] };
        let i = Math.floor(Math.log(bytes) / Math.log(SIZE_BASE));

        return {
            value: parseFloat((bytes / Math.pow(SIZE_BASE, i)).toFixed(precision)),
            unit: showSpeed ? SPEED_UNITS[i] : SIZE_UNITS[i]
        };
    }

    fromBytesTo(bytes, unitSize, showSpeed = false, precision = SIZE_PRECISION) {
        let i = showSpeed ? SPEED_UNITS.indexOf(unitSize) : SIZE_UNITS.indexOf(unitSize),
            divider = Math.pow(SIZE_BASE, i);
        return parseFloat((bytes / divider).toFixed(precision));
    }

    toBytes(value, unit) {
        const exp = SIZE_UNITS.indexOf(unit);
        return value * Math.pow(SIZE_BASE, exp);
    }

    expressBytes(bytes, showSpeed, showUnits = true) {
        if (bytes < 0) return;
        const size = this.fromBytes(bytes, showSpeed);
        return `${size.value} ${showUnits ? this.$filter('translate')(`common.unit.default.size.${size.unit}`) : ''}`;;
    }

    roundValue(value, decimals) {
        decimals = decimals || 0;
        let response = Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
        return !isNaN(response) ? response : 0;
    }

    getLocalDateFormat(type) {
        return this.localDateFormatList[!type ? 'short' : type];
    }

    getDateTimeLocaleFormat(showTime, formatType) {
        const locale = window.navigator.userLanguage || window.navigator.language || 'en',
            timeFormat = showTime ? 'datetime' : 'date',
            dateFormat = this.getLocalDateFormat(formatType);
        return {
            locale: locale,
            format: dateFormat[timeFormat],
            timezone: moment.tz.guess()
        };
    }

    getDatePickerLocalOptions(showTime, widgetPositioning, hideClear, formatType) {
        let temp = this.getDateTimeLocaleFormat(showTime, formatType);
        return {
            locale: temp.locale,
            format: temp.format,
            widgetPositioning: !!widgetPositioning ? widgetPositioning : { horizontal: 'left', vertical: 'top' },
            showClear: !hideClear
        };
    }

    formatTime(secs) {
        let hours = Math.floor(secs / 3600);
        let minutes = Math.floor((secs - (hours * 3600)) / 60);
        let seconds = secs - (hours * 3600) - (minutes * 60);
        let result = '';

        if (hours !== 0) {
            result += hours + 'h ';
        }
        if (minutes !== 0) {
            result += minutes + 'min ';
        }
        if (seconds !== 0) {
            result += seconds + 's';
        }

        return result;
    }

    roundTime(secs) {
        let temp = Math.floor(secs / (3600 * 24));
        if (temp) {
            return temp + ' ' + (temp === 1 ? 'Day' : 'Days');
        }
        temp = Math.floor(secs / (3600));
        if (temp) {
            return temp + ' h';
        }
        temp = Math.floor(secs / (60));
        if (temp) {
            return temp + ' min';
        }
        return secs + ' s';
    }

    converFromMillis(ms) {
        let hours = Math.floor(ms / (60 * 60 * 1000)),
            hoursms = ms % (60 * 60 * 1000),
            minutes = Math.floor((hoursms) / (60 * 1000)),
            minutesms = ms % (60 * 1000),
            sec = Math.floor((minutesms) / (1000));
        return {
            hours: hours,
            minutes: minutes,
            sec: sec
        };
    }

    getGreatestCommonDivisor(a, b) {
        return b ? this.getGreatestCommonDivisor(b, a % b) : a;
    }

    printRatio(a, b) {
        a = parseFloat(this.fromBytes(a).value).toFixed(0);
        b = parseFloat(this.fromBytes(b).value).toFixed(0);

        const gcd = this.getGreatestCommonDivisor(a, b);
        const ra = (a / gcd);
        const rb = (b / gcd);

        return (isNaN(ra) || isNaN(rb) ? 0 : parseFloat(ra / rb).toFixed(0)) + ':1';
    }

    copyToClipboard(elementId, item, icon) {
        let selection = this.$window.getSelection();
        let reportContent = this.$document[0].getElementById(elementId);
        if (this.$document[0].body.createTextRange && !icon) {
            //IE
            reportContent.style['white-space'] = 'pre';
            let ieRange = this.$document[0].body.createTextRange();
            ieRange.moveToElementText(reportContent);
            ieRange.select();
            ieRange.execCommand("copy");
            reportContent.style['white-space'] = 'pre-line';
        } else if (selection && this.$document[0].createRange) {
            //Others
            let range = this.$document[0].createRange();
            range.selectNodeContents(reportContent);
            selection.removeAllRanges();
            selection.addRange(range);
        }
        try {
            let successful = this.$document[0].execCommand('copy');
            selection.removeAllRanges();
            this.notificationService.pop({ type: successful ? 'success' : 'error', title: this.$filter('translate')(successful ? 'jobs.report.dialog.successCopy' : 'jobs.report.dialog.unsuccessCopy', { item: item }) });
        } catch (err) {
            this.notificationService.pop({ type: 'error', title: this.$filter('translate')('jobs.report.dialog.errorCopy') });
        }
    }

    enumToNiceString(strToSplit) {
        if (strToSplit && strToSplit.length > 1) {
            let str = strToSplit.indexOf('_') !== -1 ? strToSplit.toLowerCase().split('_') : strToSplit.toLowerCase().split(' ');
            for (let i = 0; i < str.length; i++) {
                str[i] = i === 0 ? str[i].charAt(0).toUpperCase() + str[i].slice(1) : str[i];
                if (str[i] === 'Vm' || str[i] === 'vm' || str[i] === 'uuid' || str[i] === 'Ip' || str[i] === 'rm' || str[i] === 'Ssh') {
                    str[i] = str[i].toUpperCase();
                }
                if (str[i] === 'linux' || str[i] === 'windows' || str[i] === 'azure') {
                    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
                }
                if (str[i] === 'Tier') {
                    str[i + 1] = str[i + 1].charAt(0).toUpperCase();
                }
            }
            return str.join(' ');
        }
        return strToSplit;
    }

    isEmpty(value) {
        return value === undefined || value === null || value === '' || value.length === 0;
    }

    focusOnElement(element, focus, delay) {
        this.$timeout(() => {
            if (!element || !element[0]) return;
            if (focus) element.focus();
            else element.blur();
        }, !delay ? 0 : delay);
    }


    reloadTranslateData(newLangValue) {
        let storageLang = this.storageService.getLang();
        // IF USER LANG IS SET AND DIFF THAN STORAGE LANG => RESET STORAGE LANG
        // if(user && user.usersLanguageLocale) {
        //     let userLang = user.usersLanguageLocale === 'ja_JP' ? 'JP' : user.usersLanguageLocale === 'en_US' ? 'EN' : null;
        //     if(userLang && (!storageLang || storageLang !== userLang)) {
        //         this.storageService.setLang(userLang);
        //         storageLang = userLang;
        //     }
        // }
        // IF NEW LANG VALUE IS DIFF THAN STORAGE LANG => RESET STORAGE LANG
        if (newLangValue && newLangValue !== storageLang) {
            this.storageService.setLang(newLangValue);
            storageLang = newLangValue;
        }
        return this.translateService.loadData(storageLang);
    }

    // internal usage - convert .properties to .json
    //this.getPropertiesTranslation('gui_backup_lang', 'resources/lang/gui_backup_lang_en.properties');
    //this.getPropertiesTranslation('shared_lang', 'resources/lang/shared_lang_en.properties');
    getPropertiesTranslation(fileName, path) {
        return this.$http.get(path).then((response) => {
            let responseData = response && response.data ? response.data : null;
            if (!responseData) return;
            this.testTranslations = {};
            responseData
                .split('\r\n')
                .join('\n')
                .split('\n')
                .filter(line => line)
                .forEach(line => {
                    let index = line.indexOf('=');
                    let key = line.substring(0, index);
                    let value = line.substring(index + 1);
                    value = value.replace(/(\\%)/g, '%');
                    index > 0 && (this.testTranslations[key] = value);
                });
            this.exportPropertiesToJsonData(fileName);
        }).catch(err => console.log(`(L10n) Error loading`, err));
    }
    exportPropertiesToJsonData(fileName) {
        let format = 'json',
            data = this.testTranslations;
        let newData = {};
        let tempKeys = Object.keys(data).map(i => i);
        tempKeys = tempKeys.sort((a, b) => (a > b) ? 1 : -1);
        tempKeys.forEach(key => {
            newData[key] = data[key];
        });

        let exportData = JSON.stringify(newData);
        this.saveData(exportData, `${fileName}.${format}`, format);
    }

    getDetailsListHeight() {
        return this.$document[0].getElementsByClassName('details-overflow')[0].offsetHeight - 36;
    }

    getAllTimezones() {
        let offsetTmz = [];
        let timezones = moment.tz.names(),
            localTz = moment.tz.guess(),
            localTzIndex = 0,
            bcTzIndex = 0,
            offset;

        timezones.forEach((timezone, i) => {
            offset = moment.tz(timezone).format('Z');
            offsetTmz.push({ id: i, label: `${timezone} (UTC${offset})`, tmz: `UTC${offset}`, value: setValue(offset), name: timezone });
            if (timezone.toLowerCase() === localTz.toLowerCase()) localTzIndex = i;

        });
        function setValue(str) {
            let h, m, s;
            s = str.split(':');
            h = s[0];
            m = s[1];
            return Number(h) * 60 + Number(m);
        }
        offsetTmz.sort((a, b) => a.value - b.value);
        timezones = offsetTmz;
        return timezones;
    }

    getLocalUTCOffset() {
        const localDate = new Date();
        const sign = (localDate.getTimezoneOffset() > 0) ? "-" : "+";
        const offset = this.convertToHourMinutes(Math.abs(localDate.getTimezoneOffset()));
        return 'UTC' + sign + offset;
    }

    convertToHourMinutes(minutes) {
        let h = Math.floor(minutes / 60), m = minutes % 60;
        return (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m);
    }



}
UtilsService.$inject = ['$state', '$q', '$window', '$sce', '$filter', '$timeout', '$document', '$http', 'principalService', 'notificationService', 'config', 'storageService', 'translateService'];

module.exports = UtilsService;


// WEBPACK FOOTER //
// ./src/azurebackup/services/utils.service.js